'use strict';

const { appendToUrl } = require("../domUtil");

function getParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function addParameterToURL(param, value, url) {
    url += (url.split('?')[1] ? '&' : '?') + param + '=' + value;
    return url;
}

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    let name = cookieName + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        let cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

module.exports = function () {
    if ($('.valid-cookie-warning').length > 0) {
        var previousSessionID = window.localStorage.getItem('previousSid');
        var currentSessionID = getCookie('sid');
        if (!previousSessionID && currentSessionID) {
            // When a user first time visit the home page,
            // set the previousSessionID to currentSessionID
            // and Show the cookie alert
            previousSessionID = currentSessionID;
            window.localStorage.setItem('previousSid', previousSessionID);
            $('.cookie-warning-messaging').show();
        } else if (previousSessionID && previousSessionID === currentSessionID) {
            // Hide the cookie alert if user is in the same session
            $('.cookie-warning-messaging').hide();
        } else {
            // Clear the previousSessionID from localStorage
            // when user session is changed or expired
            previousSessionID = '';
            window.localStorage.removeItem('previousSid');
        }
    }
    $(document).ready(function () {
        let utmSourceQuery = getParameterByName('utm_source', window.location.href);
        let smsClickIdQuery = getParameterByName('smsclickid', window.location.href);
        if (utmSourceQuery && utmSourceQuery === 'ShopMy' && !window.sessionStorage.getItem('utm_source')) {
            window.sessionStorage.setItem('utm_source', utmSourceQuery);
        } else if (!utmSourceQuery && window.sessionStorage.getItem('utm_source')) {
            let newUrl = addParameterToURL('utm_source', window.sessionStorage.getItem('utm_source'), window.location.href);
            window.history.replaceState({}, document.title, newUrl);
        }
        if (smsClickIdQuery && !window.sessionStorage.getItem('smsclickid')) {
            window.sessionStorage.setItem('smsclickid', smsClickIdQuery);
        } else if (!smsClickIdQuery && window.sessionStorage.getItem('smsclickid')) {
            let newUrl = addParameterToURL('smsclickid', window.sessionStorage.getItem('smsclickid'), window.location.href);
            window.history.replaceState({}, document.title, newUrl);
        }
    });
};
